import {BBModel} from '../bb_model';
import {ScheduleRules} from './schedule_rules';
import {BBAssets} from './bb_assets';
import {bbTimeZone} from '../utils/time_zone';

const schedule_cache = {};

const cacheDates = function (asset, dates) {
    if (!schedule_cache[asset.self]) {
        schedule_cache[asset.self] = {};
    }
    return (() => {
        const result = [];
        for (const k in dates) {
            const v = dates[k];
            result.push(schedule_cache[asset.self][k] = v);
        }
        return result;
    })();
};

const getCacheDates = function (asset, start, end) {

    if (!schedule_cache[asset.self]) {
        return false;
    }

    const asset_cache = schedule_cache[asset.self];

    const current = start.clone();
    const upperLimit = end.endOf('day');

    const dates = {};

    // Get all days that are between start and end date.
    while (current.isBefore(upperLimit)) {
        const day = current.format('YYYY-MM-DD');
        if (!asset_cache[day]) {
            return false;
        }

        dates[day] = asset_cache[day];
        current.add(1, 'day');
    }

    return dates;
};

// return a promise to resolve any existing schedule caching stuff
const loadScheduleCaches = function (assets = []) {
    const proms = assets.map((asset) => {
        if (asset.$has('immediate_schedule')) {
            return asset.$get('immediate_schedule')
                .then(schedules => cacheDates(asset, schedules.dates))
                .catch(console.error);
        } else {
            return Promise.resolve();
        }
    });

    if (proms.length > 0) {
        return Promise.all(proms);
    } else {
        return Promise.resolve();
    }
};

const adminSchedule = {

    query(params) {
        const {company} = params;
        return new Promise((resolve, reject) => {
            company.$get('schedules').then(collection =>
                    collection.$get('schedules').then((schedules) => {
                            const models = (Array.from(schedules).map(s => new BBModel.Admin.Schedule(s)));
                            return resolve(models);
                        }
                        , err => reject(err))

                , err => reject(err));
        });
    },


    delete(schedule) {
        return new Promise((resolve, reject) => {
            schedule.$del('self').then((schedule) => {
                    schedule = new BBModel.Admin.Schedule(schedule);
                    return resolve(schedule);
                }
                , (err) => {
                    return reject(err);
                }
            );

        });
    },

    update(schedule) {
        return new Promise((resolve, reject) => {
            schedule.$put('self', {}, schedule.getPostData()).then((c) => {
                    schedule = new BBModel.Admin.Schedule(c);
                    return resolve(schedule);
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    },

    mapAssetsToScheduleEvents(start, end, assets, options) {

        const mapEvents = function (asset, e) {
            e.assetType = options.type;
            e.resourceId = asset.id;
            e.title = asset.name;
            e.rendering = 'background';

            e.start = bbTimeZone.convertToCompany(e.start);
            e.end = bbTimeZone.convertToCompany(e.end);

            e.start = bbTimeZone.convertToDisplay(e.start);
            e.end = bbTimeZone.convertToDisplay(e.end);

            return e;
        };

        return _.map(assets, (asset) => {

            const companyStart = bbTimeZone.convertToCompany(start);
            const companyEnd = bbTimeZone.convertToCompany(end);

            let events, rules;
            const found = getCacheDates(asset, companyStart, companyEnd);
            if (found) {
                rules = new ScheduleRules(found);
                events = rules.toEvents();
                _.each(events, mapEvents.bind(null, asset));
                return new Promise((resolve, reject) => {
                    resolve(events);
                });

            } else if (asset.$has('schedule')) {
                const params = {
                    start_date: companyStart.format('YYYY-MM-DD'),
                    end_date: companyEnd.format('YYYY-MM-DD')
                };

                return asset.$get('schedule', params).then((schedules) => {
                    // cacheDates(asset, schedules.dates)
                    rules = new ScheduleRules(schedules.dates);
                    events = rules.toEvents();
                    _.each(events, mapEvents.bind(null, asset));
                    return events;
                })
                    .catch((err) => {
                        if (err.response && err.response.status === 404) {
                            console.warn(`No schedule available for: ${asset.id} - '${asset.name}' but HAL link for it exists.`);
                        } else {
                            console.error(`Error fetching schedule for ${asset.id} - '${asset.name}'`);
                            console.error(err);
                        }
                    });
            } else {
                return [];
            }

        });
    },

    getAssetsScheduleEvents(company, start, end, options) {

        let filtered = !options.showAll;
        let requested = options.selectedResources;

        if (filtered == null) {
            filtered = false;
        }
        if (requested == null) {
            requested = [];
        }
        if (filtered) {
            return loadScheduleCaches(requested).then(() => {
                    return Promise.all(this.mapAssetsToScheduleEvents(start, end, requested, options)).then(schedules => _.flatten(schedules));
                }
            );
        } else {
            const localMethod = this.mapAssetsToScheduleEvents;
            return BBAssets.getAssets(company, options.type).then(assets =>
                loadScheduleCaches(assets).then(() =>
                    Promise.all(localMethod(start, end, assets, options)).then(schedules => _.flatten(schedules))
                )
            );
        }
    }
};

export {
    adminSchedule
};
